export const signIn = (credentials) => {
  return (dispatch) => {
    dispatch({ type: "SIGNIN_SUCCESS", payload: credentials });
  };
};

export const signOut = () => {
  return (dispatch) => {
    dispatch({ type: "SIGNOUT" });
  };
};

export const updateInfo = (credentials) => {
  return (dispatch) => {
    dispatch({ type: "UPDATE_INFO", payload: credentials });
  };
};
